import React from 'react';
import { HeaderTitleStyle } from './style';

export default function HeaderTitle({ linkIcon, text, logoImage = false, nameLogo, linkLogo, urlLogo }) {
  return (
    <HeaderTitleStyle>
      <img src={linkIcon} alt={text} />
      <h2>{text}</h2>
      {logoImage && (
        <a href={urlLogo} target="_blank" rel="noreferrer">
          <img src={linkLogo} alt={nameLogo} />
        </a>
      )}
    </HeaderTitleStyle>
  );
}
